import React from 'react'

function RingsList() {
  return (
    <div>RingsList</div>
  )
}

export default RingsList